import React from 'react';
import {
    Avatar,
    Box, Link,
    Sheet,
    Stack,
    Typography
} from '@mui/joy';
import {ProjectModel} from "../model/project";
import {Launch} from "@mui/icons-material";

function GraphicWork({project}: { project: ProjectModel }) {
    let size = 0;
    let maxSize = 0;
    let width, height = 0;
    if (window.innerWidth < 620) {
        size = window.innerWidth;
    } else {
        size = window.innerWidth / 2;
    }
    if (window.innerWidth > window.innerHeight) {
        maxSize = window.innerHeight;
    } else {
        maxSize = window.innerWidth;
    }

    console.log("URL : ",project.url)
    return (
        <Sheet sx={{paddingY: 0, borderRadius: 8}}>
            <Link href={`/work/${project.title.toLowerCase().replaceAll(' ', '-')}`} variant="plain" underline="none">
                <Stack alignItems={{xs: 'center', md: 'flex-start'}} justifyContent={{xs: 'center', md:'space-between'}} direction={{xs: 'column', md: 'row'}}>
                    <Stack width={{xs:"100%",md:0}} sx={{display: {xs: 'block', md: 'none'}}}  direction='column'>
                        <Typography sx={{display: {xs: 'block', md: 'none'}}} color='primary' level="title-md">{project.category}</Typography>
                        <Typography sx={{display: {xs: 'block', md: 'none'}}} key={project.title} level='h3' fontWeight='lg'>{project.title} </Typography>
                    </Stack>
                    <Stack py={2} alignItems='center'>
                        <Box bgcolor='neutral.50' display='flex' justifyContent='center' alignItems='center'
                             height={{xs: window.innerWidth - 32, md: window.innerWidth * 0.5}}
                             maxHeight={window.innerHeight - 96}
                             maxWidth={window.innerWidth - 64}
                             width={{xs: window.innerWidth - 32, md: window.innerWidth * 0.5}}>
                            <Box component="img" src={project.url} maxWidth="100%" maxHeight="100%"/>
                        </Box>

                    </Stack>
                    <Stack p={{xs:0,md:2}} width={{xs: '100%', md: 'auto'}}  spacing={1} direction="column">
                        <Typography textAlign='left' display={{xs: 'none', md: 'block'}} color='primary'
                                    level="title-md">{project.category}</Typography>
                        <Typography textAlign='left' display={{xs: 'none', md: 'block'}} key={project.title} level='h3'
                                    fontWeight='lg'>{project.title} </Typography>
                        <Typography key={project.description} sx={{
                            overflow: 'hidden',
                            display: '-webkit-box',
                            textOverflow: 'ellipsis',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                        }} textAlign='left' color='neutral'>{project.description} </Typography>
                        <Avatar size='sm' variant='soft'>
                            <Launch fontSize='small'/>
                        </Avatar>
                    </Stack>
                </Stack>
            </Link>
        </Sheet>
    );
}

export default GraphicWork;